import { Button, Stack, Typography } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { ProTag } from '../../../../../code/src/components/ProTag/ProTag'
import { ToggleButton } from '@dtx-company/shared-components/src/components/atoms/ToggleButton/index'
import { ToggleButtonList } from '@dtx-company/shared-components/src/components/molecules/ToggleButtonList'
import { capitalize } from '@dtx-company/true-common/src/utils/strings'
import { stopPropagationEvents } from '../../../components/profile/PageEditor/components/LinkEditDrawer/LinkEditDrawer.utils'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useLockedFeatureAction } from '../../../../../common/src/components/LockedFeatureModal/hooks/useLockedFeatureAction'
import styled from 'styled-components'

const MobileStyledToggleButton = styled(ToggleButton)`
  :hover {
    background-color: white;
  }
`

interface DisplayToggleProps {
  onChange: (e: any, type: string) => void
  displayType: string
  displayOptions: { title: string; value: string; isLockedFeature?: boolean; disabled?: boolean }[]
  name?: string
  title?: string
  width?: Array<string>
  hideLabel?: boolean
}

export const DisplayToggle: FC<DisplayToggleProps> = ({
  onChange,
  displayType,
  displayOptions,
  title,
  width = ['100%', '60%', '60%'],
  hideLabel = false
}) => {
  const { hasOperation } = useAuthState()
  const showLock = !hasOperation('view:flowpage_paid_crm')
  const openLockedFeatureModal = useLockedFeatureAction({
    lockedFeatureName: 'view:flowpage_paid_crm'
  })
  const hasLockedFeature = displayOptions.some(option => option.isLockedFeature === true)

  return (
    <Stack width={width} gap={2}>
      {!hideLabel && <Typography variant="h4">{title || 'Display Type'}</Typography>}
      <Stack direction="row" alignItems="center">
        {displayOptions.map(option => (
          <Button
            variant="contained"
            color={displayType === option.value ? 'tertiary' : 'secondary'}
            key={option.value}
            disabled={option?.disabled}
            aria-label={`${option.title} toggle on`}
            onClick={e => onChange(e, option.value)}
          >
            {capitalize(option.title)}
          </Button>
        ))}

        {hasLockedFeature && showLock && (
          <ProTag
            onClick={() => {
              openLockedFeatureModal({})
            }}
          />
        )}
      </Stack>
    </Stack>
  )
}

export const MinimalDisplayToggle: FC<DisplayToggleProps> = ({
  onChange,
  displayType,
  displayOptions
}) => {
  return (
    <ToggleButtonList
      selectedValue={displayType}
      onChange={onChange}
      padding="4px"
      width="100%"
      backgroundColor={'rgba(118, 118, 128, 0.24)'}
      background="secondary.border"
      justifyContent="space-between"
      {...stopPropagationEvents}
    >
      {displayOptions.map(displayOption => (
        <MobileStyledToggleButton
          key={displayOption.value}
          border="none"
          inverse
          height="24px"
          value={displayOption.value}
        >
          <Typography>{displayOption.title}</Typography>
        </MobileStyledToggleButton>
      ))}
    </ToggleButtonList>
  )
}
